import { render, staticRenderFns } from "./dgEdit.vue?vue&type=template&id=99906acc&scoped=true"
import script from "./dgEdit.vue?vue&type=script&lang=js"
export * from "./dgEdit.vue?vue&type=script&lang=js"
import style0 from "./dgEdit.vue?vue&type=style&index=0&id=99906acc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99906acc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99906acc')) {
      api.createRecord('99906acc', component.options)
    } else {
      api.reload('99906acc', component.options)
    }
    module.hot.accept("./dgEdit.vue?vue&type=template&id=99906acc&scoped=true", function () {
      api.rerender('99906acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/lists/dgEdit.vue"
export default component.exports